module.exports = __webpack_public_path__ + "img/1.23e0d603.png";